/**
 * Breakpoint constants for consistent use across CSS and JavaScript
 * Desktop starts at 1024 (--bp-desktop-min in ui/tokens/foundations.css).
 */
export const BREAKPOINTS = {
  mobile: 767,
  tablet: 1024,
  smallDesktop: 1440,
  desktop: 1920,
} as const;

/**
 * Media query strings for use in JavaScript
 */
export const MEDIA_QUERIES = {
  mobile: `(max-width: ${BREAKPOINTS.mobile}px)`,
  tablet: `(min-width: ${BREAKPOINTS.mobile + 1}px) and (max-width: ${BREAKPOINTS.tablet}px)`,
  smallDesktop: `(min-width: ${BREAKPOINTS.tablet + 1}px) and (max-width: ${BREAKPOINTS.smallDesktop - 1}px)`,
  desktop: `(min-width: ${BREAKPOINTS.smallDesktop}px)`,
  largeDesktop: `(min-width: ${BREAKPOINTS.desktop}px)`,
} as const;

